/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Load_Type_Percent_RangeInputs */

const fr_load_type_percent_range = /** @type {(inputs: Load_Type_Percent_RangeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pourcentage (plage)`)
};

/**

* @param {Load_Type_Percent_RangeInputs} inputs
* @param {{ locale?: "fr" }} options
* @returns {LocalizedString}
*/
export const load_type_percent_range = /** @type {((inputs?: Load_Type_Percent_RangeInputs, options?: { locale?: "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Load_Type_Percent_RangeInputs, { locale?: "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return fr_load_type_percent_range(inputs)
});